// export default function Get_Api_without_Payload(endPoint, userToken) {
//     return new Promise((resolve, reject) => {
//         const xhr = new XMLHttpRequest();
//         xhr.open('GET', `${endPoint}`);
//         xhr.setRequestHeader('Content-Type', 'application/json');
//         xhr.setRequestHeader('Authorization', `Bearer ${userToken}`);

//         xhr.onload = function () {
//             if (xhr.status === 200) {
//                 resolve(xhr.responseText);
//             } else {
//                 reject(`${JSON.parse(xhr?.response)?.detail}`);
//             }
//         };
//         xhr.onerror = () => reject('Request failed');
//         xhr.send();
//     });
// }

export default function GetApiwithoutPayload(endPoint, userToken) {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL('./worker.js', import.meta.url));

        worker.postMessage({ endPoint, userToken });

        worker.onmessage = (event) => {
            console.log(event?.data, "data346cw3dszx1vyuhy2")
            if (event.data.success) {
                resolve(event.data.data);
            } else {
                reject(event.data.error);
            }
            worker.terminate();
        };
    });
}


export function PostApiwithPayload(endPoint, userToken, body) {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL('./worker.js', import.meta.url));

        worker.postMessage({ endPoint, userToken, method: 'POST', body });

        worker.onmessage = (event) => {
            if (event.data.success) {
                resolve(event.data.data);
            } else {
                reject(event.data);
            }
            worker.terminate();
        };
    });
}

export { GetApiwithoutPayload };

export function PutApiwithPayload(endPoint, userToken, body) {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL('./worker.js', import.meta.url));

        worker.postMessage({ endPoint, userToken, method: 'PUT', body });

        worker.onmessage = (event) => {
            if (event.data.success) {
                resolve(event.data.data);
            } else {
                reject(event.data.error);
            }
            worker.terminate();
        };
    });
}


export function DeleteApiwithPayload(endPoint, userToken, body) {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL('./worker.js', import.meta.url));

        worker.postMessage({ endPoint, userToken, method: 'DELETE', body });

        worker.onmessage = (event) => {
            if (event.data.success) {
                resolve(event.data.data);
            } else {
                reject(event.data.error);
            }
            worker.terminate();
        };
    });
}

// useEffect(() => {
//     Get_Api_without_Payload(authentication?.staffing_list,'')
//         .then((data) => {
//             console.log(data, "ddddddddd");
//         })
//         .catch((error) => console.error(error, "ddddddddderrrr"));
// }, []);

